import { render } from "./ActionMenu.vue?vue&type=template&id=2d6265a2&scoped=true"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"

import "./ActionMenu.vue?vue&type=style&index=0&id=2d6265a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6265a2"]])

export default __exports__